// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"240":"e166b5f3","437":"697c4449","614":"24553540","807":"7792e3c7"}[chunkId] + ".chunk.css";
};